import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { ShopifyConnection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-shopify',
  template: `
    <xp-form-validation type="ShopifyConnection" [name]="formName">
      <form id="connectionFormShopify" name="connectionFormShopify" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group class="has-feedback">
              <label for="shop">{{ 'connection-form-shopify.labels.account' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="shop"
                id="shop"
                [(ngModel)]="connection.shop"
                placeholder="e.g. your-shop.myshopify.com"
                ng-disabled="disableShopName"
              ></xp-input>
              <small *ngIf="!disableShopName">{{ 'connection-form-shopify.hints.sign_in_text' | translate }}</small>
            </xp-form-group>
          </div>
        </div>
        <div class="row" *ngIf="connectionTypeButtonCreate">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
            <xp-form-group *ngIf="connection.username">
              <label for="username">{{ 'connections.form.labels.username' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="username"
                id="username"
                [(ngModel)]="connection.username"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </xp-form-group>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormShopifyComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<ShopifyConnection> = {};
  @Input() connectionTypeButtonCreate: boolean;
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormShopify';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
  ) {
    super();
  }

  get disableShopName(): boolean {
    return !!this.connection.id || !!this.connection.code || !!this.connection.jwt_token;
  }
}
